module.exports = __webpack_public_path__ + "static/media/logo-etex.f8a5cfa5.svg";